import { FolderIcon, GlobeIcon, TableIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Menu } from '../../../Menu'

export type DrawerCreateCollectionMenuProps = {
  workspace?: string
  onCreateCollectionClick?: () => void
  onCreateFolderClick?: () => void
  onOpenTemplateGalleryClick?: () => void
}

export function DrawerCreateCollectionMenu (props: DrawerCreateCollectionMenuProps) {
  const { workspace, onCreateCollectionClick, onCreateFolderClick, onOpenTemplateGalleryClick } = props

  const { t } = useTranslation()

  return (
    <Menu>
      <li>
        <a onClick={() => onCreateFolderClick?.()}>
          <FolderIcon size={16} />
          {t('collectionAndFolderActions:New folder')}
        </a>
      </li>
      <li>
        <a onClick={() => onCreateCollectionClick?.()}>
          <TableIcon size={16} />
          {t('collectionAndFolderActions:New empty collection')}
        </a>
      </li>
      <li>
        <Link
          to={`/${workspace}/templates`}
          onClick={() => onOpenTemplateGalleryClick?.()}
        >
          <GlobeIcon size={16} />
          {t('collectionAndFolderActions:Open template gallery')}
        </Link>
      </li>
    </Menu>
  )
}
